"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleProductCodeInList = void 0;
const toggleProductCodeInList = (code, list) => {
  if (list.includes(code)) {
    return list.filter(listItem => listItem !== code);
  }
  return [...list, code];
};
exports.toggleProductCodeInList = toggleProductCodeInList;
//# sourceMappingURL=toggleProductCodeInList.js.map